(() => {
  if (customElements.get('tsc-mattress-menu')) return;
  class TscMattressMenu extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced) return;
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.accordions = [...this.querySelectorAll('[data-accordion]')];
      this.mobile = this.dataset.instance === 'mobile';
      this.querySelector('.tsc-menu__tabs').setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        const panel = this.panels[index];
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panel.id);
        tab.addEventListener('click', () => this.select(tab.dataset.tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault(); event.stopPropagation();
          this.select(this.tabs[next].dataset.tab);
          this.tabs[next].focus();
        });
        const accordion = this.accordions[index];
        accordion.setAttribute('aria-controls', panel.id);
        accordion.addEventListener('click', () => {
          const key = this.selected === accordion.dataset.accordion ? null : accordion.dataset.accordion;
          this.select(key);
          const scroller = this.closest('.menu-drawer__inner-submenu');
          if (key && this.mobile && scroller) {
            // Scroll only the drawer, leaving the page and its close control in place.
            const backHeight = scroller.querySelector('.tsc-drawer__back')?.getBoundingClientRect().height || 0;
            scroller.scrollTop += accordion.getBoundingClientRect().top - scroller.getBoundingClientRect().top - backHeight - 12;
          }
        });
        panel.setAttribute('role', this.mobile ? 'region' : 'tabpanel');
        panel.setAttribute('aria-labelledby', this.mobile ? accordion.id : tab.id);
      });
      const selector = this.querySelector('[data-price-size]');
      selector?.addEventListener('change', () => {
        this.querySelectorAll('[data-price-link]').forEach(link => {
          const url = new URL(link.href, window.location.href);
          url.searchParams.set('size', selector.value);
          link.href = url.pathname + url.search;
        });
        this.querySelectorAll('[data-size-label]').forEach(label => { label.textContent = selector.value; });
      });
      this.querySelectorAll('.tsc-menu__brand img').forEach(img => {
        const fallback = () => { img.hidden = true; img.nextElementSibling.hidden = false; };
        img.addEventListener('error', fallback);
        if (img.complete && img.naturalWidth === 0) fallback();
      });
      this.dataset.enhanced = 'true';
      this.select(this.mobile ? null : this.tabs[0]?.dataset.tab);
    }
    select(key) {
      this.selected = key;
      this.tabs.forEach(tab => {
        const active = tab.dataset.tab === key;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.panel !== key; });
      this.accordions.forEach(button => {
        const active = button.dataset.accordion === key;
        button.setAttribute('aria-expanded', String(active));
        button.querySelector('span').textContent = active ? '−' : '+';
      });
    }
  }
  customElements.define('tsc-mattress-menu', TscMattressMenu);
  customElements.define('tsc-category-menu', class extends TscMattressMenu {});
})();
